import styled from 'styled-components'

import { Navbar, SidebarPlaceholder } from '@sketch/components'

interface PlaceholderProps {
  $expanded: boolean
}

export const ToggleButton = styled(Navbar.Button)`
  width: 40px;
  height: 40px;
`

export const Wrapper = styled(SidebarPlaceholder)<PlaceholderProps>`
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
  width: ${({ theme, $expanded }) =>
    // grow 8px extra for correct distance with other header items
    $expanded ? theme.sidebar.canvasFirstRightWidth + 8 : 40}px;
`
